import { FiImage, FiMaximize } from "react-icons/fi";
import { RiRulerLine } from "react-icons/ri";
import styles from "../../styles/home.module.css";
import arImage from "../../assets/ar.jpeg";
import arVideo from "../../assets/motion.mp4";

const STEPS = [
  { icon: <FiImage />, text: "ارفع صورة الحائط" },
  { icon: <RiRulerLine />, text: "اكتب عرض الحائط" },
  { icon: <FiMaximize />, text: "اختر اللوحة وحرّكها" },
];

const ArSection = ({ onStart }) => {
  return (
    <section id="ar" className={styles.section}>
      <div className={styles.panelBox}>
        <div className={styles.arContent}>
          <h2>جرّب لوحتك على حائطك</h2>

          <div className={styles.arSteps}>
            {STEPS.map((step, i) => (
              <div key={i} className={styles.arStep}>
                <div className={styles.arStepIcon}>{step.icon}</div>
                <span>{step.text}</span>
              </div>
            ))}
          </div>

          <button type="button" onClick={onStart} className={styles.cta}>
            ابدأ التجربة الآن
          </button>
        </div>

        <div className={styles.phone}>
          <div className={styles.phoneBody}>
            <div className={styles.phoneScreen}>
              <video
                src={arVideo}
                poster={arImage}
                className={styles.phoneImage}
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                aria-label="خطوات تجربة اللوحة على حائطك"
              />
            </div>
          </div>
        </div>
      </div>

      <p className={styles.note}>
        للأفضل نتيجة: صوّر الحائط كاملاً بشكل مستقيم مع جزء من الأثاث.
      </p>
    </section>
  );
};

export default ArSection;
